import Slider from "react-slick";
import { Container } from "react-bootstrap";
import "./carousel.css";

const rajaRam =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/rajaram.webp";
const balaji =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/jogi-balaji.webp";
const vidya_Prabha =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/vidhya-prabha.webp";

const testimonials = [
  {
    imgSrc: rajaRam,
    name: "Rajaram G",
    text: "ACube is a great place for young and creative minds to apply their skills and knowledge they possess and let their talent prosper in a positive working environment. ACubetech Solutions is a process driven organization which provides immense learning opportunities. There is transparency in the processes followed and this helps things happen on time for the employees. In turn, our resources provide quality products to the customer and keep them happy. Hard work and dedication never go unnoticed here, and these directly translate to career growth and rewards. I’m indeed happy to be a part of this organization and wish the organization the very best of everything in all its endeavors.",
  },
  {
    imgSrc: balaji,
    name: "Balaji Jogi, Development Team.",
    text: "ACube is a nice place to work with; colleagues and supervisors are always ready to provide their support. I feel proud that I am a part of such great company. Here I get chance to groom myself personally as well as professionally.",
  },
  {
    imgSrc: vidya_Prabha,
    name: "Vidya Prabha, Tech Lead.",
    text: "The organization focuses on bringing out the best in an employee. ACube has provided us with some basic yet important trainings like Corporate Etiquette, Time Management and Goal Setting. These have been of great help in grooming and development. It is nice to be a part of this Organization",
  },
];

const EmployeeCarousel = () => {
  const testimonialCarousel = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
    ],
  };

  return (
    <section className="employee-carousel testimonial-section px-0">
      <Container fluid>
        <h2 className="title-text text-uppercase text-center text-primary ft-wt-700 mb-3 mb-lg-5">
          Employee Speak
        </h2>
        <Slider {...testimonialCarousel} className="testimonial-carousel">
          {testimonials.map((testimonial, index) => (
            <div className="pt-50" key={index}>
              <div className="testimonial-img-div">
                <img
                  className="mb-3 testimonial-img"
                  loading="lazy"
                  src={testimonial.imgSrc}
                  alt={testimonial.name}
                  height="100"
                />
              </div>
              <div className="bg-white p-4 pb-5 mx-3 rounded-4 card-height h-100">
                <div className="content-block">
                  <p className="mb-2 mb-lg-3 fw-bold text-primary">
                    {testimonial.name}
                  </p>
                  <h5 className="mb-4 text-primary">{testimonial.text}</h5>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default EmployeeCarousel;
